<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机编号" prop="businessNum">
            <el-input v-model="queryParams.businessNum" placeholder="请输入商机编号" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机名称" prop="businessNameRex">
            <el-input v-model="queryParams.businessNameRex" placeholder="请输入商机名称" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerNameRex">
            <el-input v-model="queryParams.customerNameRex" placeholder="请输入客户名称" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机级别" prop="businessLevelList">
            <el-select v-model="queryParams.businessLevelList" placeholder="请选择商机级别" clearable multiple style="width:100%">
              <el-option v-for="dict in businessLevelOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机阶段" prop="currentStageList">
            <el-select v-model="queryParams.currentStageList" placeholder="请选择商机阶段" clearable multiple style="width:100%">
              <el-option v-for="stage in businessStageOptions" :key="stage.code" :label="stage.name" :value="stage.code"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="预计成交时间" prop="estimateDealDate">
            <el-date-picker v-model="queryParams.estimateDealDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进情况" prop="followInfo">
            <el-select v-model="queryParams.followInfo" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="dict in followInfoList" :key="dict.value" :label="dict.label" :value="dict.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机规模" prop="businessScaleList">
            <el-select v-model="queryParams.businessScaleList" placeholder="请选择商机规模" multiple clearable style="width:100%">
              <el-option v-for="item in businessScaleOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :autoSelectUser="autoSelectUser"></dept-user-select>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="预计成交金额" prop="estimateDealAmount">
            <el-select v-model="queryParams.estimateDealAmount" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in estimateDealAmountOpt" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="转化天数" prop="turnDaysParam">
            <el-select v-model="queryParams.turnDaysParam" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in turnDaysOpt" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="变更时间" prop="changeTime">
            <el-date-picker v-model="queryParams.changeTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机来源" prop="businessSourceList">
            <el-select v-model="queryParams.businessSourceList" placeholder="请选择商机来源" multiple clearable style="width:100%">
              <el-option v-for="item in businessSourceOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="采购需求" prop="requirementList">
            <el-select v-model="queryParams.requirementList" placeholder="请选择" multiple clearable style="width:100%">
              <el-option v-for="item in requirementOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="项目类型" prop="projectTypeList">
            <el-select v-model="queryParams.projectTypeList" placeholder="请选择项目类型" multiple clearable style="width:100%">
              <el-option v-for="item in projectTypeOptions" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="转化中" name="turning"></el-tab-pane>
      <el-tab-pane label="已成交" name="deal"></el-tab-pane>
      <el-tab-pane label="输单" name="closed"></el-tab-pane>
      <el-tab-pane label="无效" name="invalid"></el-tab-pane>
      <el-tab-pane label="挂起" name="hang"></el-tab-pane>
      <el-tab-pane label="全部商机" name="all"></el-tab-pane>
      <el-tab-pane label="我的关注" name="myFocus"></el-tab-pane>
    </el-tabs>
    <el-row>
      <div style="font-size: 14px; margin: 10px 0">
      预计成交总额（元）：{{amountFormat(Number(otherData.sumEstimateDealAmount || 0))}}万
      </div>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="商机名称" min-width="160" align="left" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.businessName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="180" align="left" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="商机级别" width="80" align="center" prop="businessLevelDesc" fixed="left"/>
      <el-table-column label="商机编号" width="140" align="center" prop="businessNum"/>
      <el-table-column label="商机规模" width="80" align="center" prop="businessScaleDesc"/>
      <el-table-column label="商机来源" width="80" align="center" prop="businessSourceDesc"/>
      <el-table-column label="采购需求" width="180" align="center" prop="requirementsDesc" show-overflow-tooltip/>
      <el-table-column label="项目类型" width="195" align="center" prop="projectType"/>
      <el-table-column label="商机状态" width="80" align="center" prop="businessStatusDesc"/>
      <el-table-column label="商机阶段" width="80" align="center" prop="currentStageDesc"/>
      <el-table-column label="预计成交金额(元)" width="130" align="center" prop="estimateDealAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.estimateDealAmount || 0) / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="预计成交时间" width="110" align="center" prop="estimateDealDate"/>
      <el-table-column label="签约金额" width="100" align="center" prop="signAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.signAmount || 0) / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="转化天数" width="80" align="center" prop="turnDays">
        <template slot-scope="scope">
          <span>{{scope.row.turnDays || scope.row.turnDays===0 ? scope.row.turnDays + "天" : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" width="80" align="center" prop="userName"/>
      <el-table-column label="最新跟进人" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.followerName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进时间" width="170" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.createTime : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="未跟进天数" width="90" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowIntervalDay || scope.row.lastFollowIntervalDay===0 ? scope.row.lastFollowIntervalDay + "天" : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="80" align="center" prop="createUserName"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime" />
      <el-table-column label="关注" min-width="80" align="center" prop="focusFlag" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.focusFlag" @change="focusChange($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
          <el-button type="text"  @click="handlePlan(scope.row)">计划</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <PlanAddDialog ref="planAddDialogRef" @success="getList"></PlanAddDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <AddBusinessDialog ref="addBusinessDialogRef" @success="getList"></AddBusinessDialog>
  </div>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import PlanAddDialog from "@/views/crm/plan/planAddDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import AddBusinessDialog from "@/views/crm/business/addBusinessDialog";
import {queryListBusiness} from "@/api/crm/business";
import { queryDefaultTemplateStage } from "@/api/crm/template";
import { mapState } from 'vuex'
import { amountFormat } from '@/utils/index'
import {changeStatus} from "@/api/crm/focus";
import deptUserSelect from "@/views/crm/components/deptUserSelect";


export default {
  name: "BusinessManage",
  data() {
    return {
      amountFormat,
      autoSelectUser: true,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      otherData: {},
      businessStageOptions: [],
      businessLevelOptions: [],
      businessScaleOptions: [],
      businessSourceOptions: [],
      requirementOptions: [],
      projectTypeOptions: [],
      followInfoList: [
        { value: 1, label: "一周内有跟进"},
        { value: 2, label: "一个月内有跟进"},
        { value: 3, label: "3个月内有跟进"},
        { value: 4, label: "3个月内无跟进"}
      ],
      estimateDealAmountOpt: [
        { value: 1, label: "0-50万"},
        { value: 2, label: "50万-100万"},
        { value: 3, label: "100万-300万"},
        { value: 4, label: "300万以上"}
      ],
      turnDaysOpt: [
        { value: 1, label: "0-30天"},
        { value: 2, label: "30天-60天"},
        { value: 3, label: "60天-90天"},
        { value: 4, label: "90天以上"}
      ],
      activeName: 'turning',
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        businessNum: null,
        businessNameRex: null,
        customerNameRex: null,
        currentStageList: [],
        businessScaleList: [],
        businessSourceList: [],
        requirementList: [],
        projectTypeList: [],
        businessLevelList: [],
        createTime: [],
        changeTime: [],
        estimateDealDate: [],
        myFocusFlag: null,
        businessStatus: 0,
        followInfo: null,
        turnDaysParam: null,
        estimateDealAmount: null,
        deptIdList: [],
        managerIdList: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog,
    PlanAddDialog,
    AddBusinessDialog,
    deptUserSelect
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    let workParams = this.$route.params // 工作台跳转进来
    if(Object.keys(workParams).length){
      this.autoSelectUser = false
      this.queryParams.createTime = workParams.createTime
      this.queryParams.estimateDealDate = workParams.estimateDealDate
      this.queryParams.deptIdList = workParams.deptIdList
      this.queryParams.managerIdList = workParams.managerIdList
    }else {
      this.autoSelectUser = true
    }
    this.getList();
    this.getDicts("business_level").then(response => {
      this.businessLevelOptions = response.data;
      this.businessLevelOptions.push({dictValue: '-1', dictLabel: '无等级'})
    });
    this.getDicts("business_scale").then(response => {
      this.businessScaleOptions = response.data;
    });
    this.getDicts("common_source").then(response => {
      this.businessSourceOptions = response.data;
    });
    this.getDicts("product_type").then(response => {
      this.requirementOptions = response.data;
    });
    this.getDicts("project_type").then(response => {
      this.projectTypeOptions = response.data;
    });
    queryDefaultTemplateStage().then(response => {
      this.businessStageOptions = response.data;
    });
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if(params.changeTime && params.changeTime.length) {
        params.changeTimeStart = params.changeTime[0]
        params.changeTimeEnd = params.changeTime[1]
      }
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      if (params.estimateDealDate && params.estimateDealDate.length > 1) {
        params.estimateDealDateBegin = params.estimateDealDate[0]
        params.estimateDealDateEnd = params.estimateDealDate[1]
      }
      if (params.estimateDealAmount === 1) {
        // 大于等于
        params.estimateDealAmountMin = 0
        params.estimateDealAmountMax = 500000
      } else if (params.estimateDealAmount === 2) {
        // 大于
        params.estimateDealAmountMinGt = 500000
        params.estimateDealAmountMax = 1000000
      } else if (params.estimateDealAmount === 3) {
        params.estimateDealAmountMinGt = 1000000
        params.estimateDealAmountMax = 3000000
      } else if (params.estimateDealAmount === 4) {
        params.estimateDealAmountMinGt = 3000000
      }
      params.createTime = undefined;
      params.estimateDealDate = undefined;
      params.changeTime = undefined;
      // 是否查看团队所在商机数据标志，默认不查看，目前只有列表入口会查看，其他跳转过来的不查
      params.queryGroupBusinessFlag = true
      queryListBusiness(params).then(response => {
          this.dataList = response.rows || []
          this.otherData = response.otherData || {}
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.createTime = []
      this.queryParams.deptIdList = []
      this.queryParams.estimateDealDate = []
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.businessId);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("business", row.businessId, row.currentStageCode);
    },
    /** 计划按钮操作 */
    handlePlan(row) {
      this.$refs.planAddDialogRef.open("business", row.id, row.userId);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addBusinessDialogRef.open();
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("business", this.ids)
    },
    focusChange (e, row) {
      let param = {
        targetId: row.id,
        targetType: 'business',
        operateType: e ? 1 : 2 // 操作类型 1-关注 2-取消关注
      }
      changeStatus(param).then(response => {
          this.msgSuccess(e ? '关注成功' : '取消关注成功')
        }
      ).finally(() => {
        this.handleQuery()
      });
    },
    handleClick (tab, event) {
      this.queryParams.myFocusFlag = null
      this.queryParams.businessStatus = null
      // 商机状态 -1-全部商机 null-默认过滤输单、无效、挂起 0-转化中 1-输单 2-已成交 3-无效 4-挂起
      if (tab.name === 'turning') {
        this.queryParams.businessStatus = 0
      } else if (tab.name === 'closed') {
        this.queryParams.businessStatus = 1
      } else if (tab.name === 'deal') {
        this.queryParams.businessStatus = 2
      } else if (tab.name === 'myFocus') {
        this.queryParams.myFocusFlag = 1
        this.queryParams.businessStatus = -1
      } else if (tab.name === 'invalid') {
        this.queryParams.businessStatus = 3
      } else if (tab.name === 'hang') {
        this.queryParams.businessStatus = 4
      } else if (tab.name === 'all') {
        this.queryParams.businessStatus = -1
      }
        this.handleQuery()
    },
  }
};
</script>
